import React from "react";
import "./style.css";
import { Grid, Typography } from "@material-ui/core";
import { isString } from "lodash";

const StatsPanel = ({ title, children, rootCSSClass = "" }) => {
  return (
    <Grid
      container
      direction="column"
      className={`stat-panel ${isString(rootCSSClass) ? rootCSSClass : ""}`}
    >
      <Typography className="panel-title">{title}</Typography>
      <Grid item container className="stat-panel-content">
        {children}
      </Grid>
    </Grid>
  );
};

export default StatsPanel;
